export default "__VITE_ASSET__DKSwMS$r__"